document.addEventListener('DOMContentLoaded', () => {

    const navToggle = document.querySelector('.js-toggleNav');
    const navigation = document.querySelector('.navigation');

    const classes = {
        openNavigation: 'show',
        activeToggle: 'active'
    }

    navToggle.addEventListener('click', () => {
        navToggle.classList.toggle(classes.activeToggle);
        navigation.classList.toggle(classes.openNavigation);
    })

})